import React from 'react';
import { Column } from '@ant-design/plots';
import { Props } from './types';
import { Datum } from '@antv/g2plot';

const DemoColumn: React.FC<Props> = ({ data }) => {
  const config = {
    data,
    xField: 'type',
    yField: 'sales',
    label: {
      style: {
        fill: '#FFFFFF',
        opacity: 0,
      },
    },
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
      },
    },

    tooltip: {
      formatter: (datum: Datum) => {
        // eslint-disable-next-line array-callback-return
        data.map((item) => {
          if (item.type === datum.type) {
            datum.percentual = item.percentual;
          }
        });
        return {
          name: `<span style="font-size: 20px">
          ${datum.sales}
          </span> atendimentos`,
          value: `<span style="font-size: 20px">
          ${datum.percentual + '%'}
          </span> dos atendimentos`,
        };
      },
    },
  };
  return <Column {...config} />;
};

export default DemoColumn;
